import { h, Component } from 'preact';
import cx from 'classnames';

import { Listing } from '../../../../types/listing.model';

export const RANK_BY_VIEWS = 'rank-by-views';
export const RANK_BY_INQUIRIES = 'rank-by-inquiries';

interface TopFiveListingsWidgetProps {
  listings: Listing[];
  title: string;
  rankedBy: string;

  hrefText: string;
  hrefLink: string;
}

interface TopFiveListingsWidgetState {
  listings: Listing[];
  isCollapseVisible?: boolean;
  isTipsVisible?: boolean;
}

export class TopFiveListingsWidget extends Component<TopFiveListingsWidgetProps, TopFiveListingsWidgetState> {
  constructor(props: TopFiveListingsWidgetProps) {
    super(props);

    this.setState({
      listings: props.listings
    });
  }

  toggleCollapsable = () => {
    this.setState({
      isCollapseVisible: !this.state.isCollapseVisible
    });
  }

  toggleTips = () => {
    this.setState({
      isTipsVisible: !this.state.isTipsVisible
    });
  }

  getDataHeadersBlock(props: TopFiveListingsWidgetProps, state: TopFiveListingsWidgetState) {
    if (props.rankedBy === RANK_BY_VIEWS) {
      return (
        <div className="col-12 d-flex ">
          <div className="hi-top-five-listings__listings__header property-id">
            Property ID
          </div>
          <div className="hi-top-five-listings__listings__header">
            Views
          </div>
          <div className="hi-top-five-listings__listings__header">
            Inquiries
          </div>
        </div>
      );
    } else if (props.rankedBy === RANK_BY_INQUIRIES) {
      return (
        <div className="col-12 d-flex ">
          <div className="hi-top-five-listings__listings__header property-id">
            Property ID
          </div>
          <div className="hi-top-five-listings__listings__header">
            Inquiries
          </div>
          <div className="hi-top-five-listings__listings__header">
            Views
          </div>
        </div>
      );
    }
  }

  getDataColumnsBlock(props: TopFiveListingsWidgetProps, listing: Listing) {
    if (props.rankedBy === RANK_BY_VIEWS) {
      return (
        <div className="col-12 hi-top-five-listings__listing mb-2">
          <div className="hi-top-five-listings__listing__details">
            <p className="hi-top-five-listings__listing__details__property-id">
              { listing.propertyKey }
            </p>
            <p className="hi-top-five-listings__listing__details__address">
              { listing.completeAddress }
            </p>
          </div>
          
          <p className="hi-top-five-listings__listing__views">
            { listing.views }
          </p>
          <p className="hi-top-five-listings__listing__inquiry-counts">
            { listing.leads }
          </p>
        </div>
      );
    } else if (props.rankedBy === RANK_BY_INQUIRIES) {
      return (
        <div className="col-12 hi-top-five-listings__listing mb-2">
          <div className="hi-top-five-listings__listing__details">
            <p className="hi-top-five-listings__listing__details__property-id">
              { listing.propertyKey }
            </p>
            <p className="hi-top-five-listings__listing__details__address">
              { listing.completeAddress }
            </p>
          </div>
          
          <p className="hi-top-five-listings__listing__inquiry-counts">
            { listing.leads }
          </p>
          <p className="hi-top-five-listings__listing__views">
            { listing.views }
          </p>
        </div>
      );
    }
  }

  getContentBlock(props: TopFiveListingsWidgetProps, state: TopFiveListingsWidgetState) {
    if (state.isTipsVisible) {
      if (props.rankedBy === RANK_BY_VIEWS) {
        return this.getViewsTipsBlock(props, state);
      }

      if (props.rankedBy === RANK_BY_INQUIRIES) {
        return this.getInquiriesTipsBlock(props, state);
      }
    } else {

      return (
        <div className={ cx('hi-widget-collapsable__body', {
          'visible': state.isCollapseVisible
        }) }>
          <div className="row">
            <div className="col-12">
              <p className="hi-top-five-listings__desc">
               All Time
              </p>
            </div>
          </div>

          {/* <div className="row mt-3">
            <div className="col-12">
              <button className="btn hi-top-five-listings__cat-toggle active">
                Rental
              </button>
              <button className="btn hi-top-five-listings__cat-toggle">
                Sale
              </button>
            </div>
          </div> */}

          <div className="row hi-top-five-listings__listings mt-4">
            {
              this.getDataHeadersBlock(props, state)
            }
            {
              props.listings ? (
                props.listings.map((listing, index) => {
                  return this.getDataColumnsBlock(props, listing);
                }) 
              ) : null
            }
          </div>
        
          <div className="row hi-top-five-listings__learn-how">
            <div className="col-12">
              <a onClick={this.toggleTips}  >
                { props.hrefText } <i className="fas fa-chevron-right"></i>
              </a>
            </div>
          </div>
        
        </div>
      );
    }
  }

  getViewsTipsBlock(props: TopFiveListingsWidgetProps, state: TopFiveListingsWidgetState) {
    return (
      <div className={ cx('hi-widget-collapsable__body', {
        'visible': state.isCollapseVisible
      }) }>
        <div className="hi-top-five-listings__tips pt-3 pb-5">
          <b>Here are some ways to get more views on your listings:</b>
          <p className="mt-3">
            People who search for homes online are drawn to a property almost instantly through photos.
          </p>
          <ol type="1" className="hi-top-five-listings__tips__list">
            <li>
              It’s always a good idea to shoot houses with natural light.
            </li>
            <li>
              Clear the view and make sure that there are no unnecessary objects lying around.
            </li>
            <li>
              Make sure to take different photos of all the rooms and areas available – living room, bedroom, bathroom, dining and kitchen.
            </li>
            <li>
              As our Partner Broker, you can also avail of our free professional photography services. 
              <i className="d-block">
                Rent listing must be worth at least P70,000
              </i>
              <i className="d-block">
                Sale listing must be worth at least 7M
              </i>
            </li>
          </ol>

          <p>
            In this technology-driven age, it’s crucial for home sellers to learn how to maximize the digital tools available for them to use to advertise their home and reach more potential buyers.
          </p>
          <ol type="1">
            <li>
              Share your listing on social media to give your property more visibility.
            </li>
            <li>
              Use a striking headline and description to grab the attention of property buyers.
            </li>
            <li>
              Do not be generic. Be original and think outside the box. Highlight a feature that you know everyone would love to have. 
            </li>
            <li>
              As our Partner Broker, you can have your listings featured on our social media (with over # of followers), newsletter (with over # of subscribers, and online magazine (with over # average monthly visits). 
            </li>
          </ol>
        </div>
      
        <div className="row hi-top-five-listings__learn-how">
          <div className="col-12">
            <a onClick={this.toggleTips}  >
              <i className="fas fa-chevron-left"></i> Go back
            </a>
          </div>
        </div>
      </div>
    );
  }

  getInquiriesTipsBlock(props: TopFiveListingsWidgetProps, state: TopFiveListingsWidgetState) {
    return (
      <div className={ cx('hi-widget-collapsable__body', {
        'visible': state.isCollapseVisible
      }) }>
        <div className="hi-top-five-listings__tips pt-3 pb-5">
          <b>Here are some ways to get more inquiries on your listings:</b>
          <p className="mt-3">
            Social media has become a major lead generator for real estate businesses, and professionals in the industry have had to sharpen their knowledge of the proper use of these platforms.
          </p>
          <ol type="1" className="hi-top-five-listings__tips__list">
            <li>
              Share your listing on social media to give your property more visibility.
            </li>
            <li>
              Choose the right channel. You don’t need to make an account on every available social media platform. Instead, choose what you can manage and what you can commit to. 
            </li>
            <li>
              As our Partner Broker, you can have your listings featured on our social media (with over # of followers), newsletter (with over # of subscribers, and online magazine (with over # average monthly visits).
            </li>
          </ol>
        </div>
        <div className="row hi-top-five-listings__learn-how">
          <div className="col-12">
            <a onClick={this.toggleTips}  >
              <i className="fas fa-chevron-left"></i> Go back
            </a>
          </div>
        </div>
      </div>
    );
  }
  
  render(props: TopFiveListingsWidgetProps, state: TopFiveListingsWidgetState) {
    return (
      <div className="hi-top-five-listings hi-widget-collapsable">
        <div className="row hi-widget-collapsable__toggle-row">
          <div className="col-10">
            <h4 className="hi-top-five-listings__name">
              { props.title }
            </h4>
          </div>
          <div className="col-2 d-md-none">
            <i className={ cx('fas fa-chevron-down', {
                'visible': state.isCollapseVisible
              })}
              onClick={ this.toggleCollapsable }>
            </i>
          </div>
        </div>
        {
          this.getContentBlock(props, state)
        }
      </div>
    );
  }
}